function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.375 2.75C8.375 2.33579 8.71079 2 9.125 2H15.125C15.5392 2 15.875 2.33579 15.875 2.75C15.875 3.16421 15.5392 3.5 15.125 3.5H9.125C8.71079 3.5 8.375 3.16421 8.375 2.75Z",
  fill: "#222222"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.125 4.25C12.5392 4.25 12.875 4.58579 12.875 5L12.875 5.75C12.875 6.16422 12.5392 6.5 12.125 6.5C11.7108 6.5 11.375 6.16422 11.375 5.75L11.375 5C11.375 4.58579 11.7108 4.25 12.125 4.25Z",
  fill: "#222222"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.21166 9.33666C5.49387 9.05445 5.95142 9.05445 6.23363 9.33666L7.03834 10.1414C7.32055 10.4236 7.32055 10.8811 7.03834 11.1633C6.75613 11.4456 6.29858 11.4456 6.01637 11.1633L5.21166 10.3586C4.92945 10.0764 4.92945 9.61887 5.21166 9.33666Z",
  fill: "#222222"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.22576 16.0242C4.92475 15.7232 4.92475 15.2352 5.22576 14.9342L5.9342 14.2258C6.2352 13.9247 6.72324 13.9247 7.02424 14.2258C7.32525 14.5268 7.32525 15.0148 7.02424 15.3158L6.3158 16.0242C6.0148 16.3253 5.52676 16.3253 5.22576 16.0242Z",
  fill: "#222222"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2117 11.1633C16.9294 10.8811 16.9294 10.4236 17.2117 10.1414L18.0164 9.33666C18.2986 9.05445 18.7561 9.05445 19.0383 9.33666C19.3206 9.61887 19.3206 10.0764 19.0383 10.3586L18.2336 11.1633C17.9514 11.4456 17.4939 11.4456 17.2117 11.1633Z",
  fill: "#222222"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2117 14.2117C17.4939 13.9294 17.9514 13.9294 18.2336 14.2117L19.0383 15.0164C19.3206 15.2986 19.3206 15.7561 19.0383 16.0383C18.7561 16.3206 18.2986 16.3206 18.0164 16.0383L17.2117 15.2336C16.9294 14.9514 16.9294 14.4939 17.2117 14.2117Z",
  fill: "#222222"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.75 17.75V11C14.75 9.55025 13.5747 8.375 12.125 8.375C10.6753 8.375 9.5 9.55025 9.5 11V17.75C9.5 19.1997 10.6753 20.375 12.125 20.375C13.5747 20.375 14.75 19.1997 14.75 17.75ZM12.125 6.875C9.84682 6.875 8 8.72182 8 11V17.75C8 20.0282 9.84682 21.875 12.125 21.875C14.4032 21.875 16.25 20.0282 16.25 17.75V11C16.25 8.72183 14.4032 6.875 12.125 6.875Z",
  fill: "#222222"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.125,
  cy: 10.625,
  rx: 1.5,
  ry: 1.5,
  fill: "#FF6D60"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.125,
  cy: 14.375,
  r: 1.5,
  fill: "#B9FF60"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.125,
  cy: 18.125,
  rx: 1.5,
  ry: 1.5,
  fill: "#FFDC60"
});

function SvgTrafficLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLight);
export default __webpack_public_path__ + "static/media/traffic-light.89b6395a.svg";
export { ForwardRef as ReactComponent };